<script>
	import model from "../../stores/modelStore";
	import lookups from "../../stores/lookupStore";
	import businesses from "../../stores/businessesStore";
	import { onMount } from "svelte";
	import { slugify, findLookupId, formatBusinessName } from "../../components/lib/helpers";
	import { unformatDate } from "../../helpers/dateHelpers";
	import { useParams } from "svelte-navigator";
	import { isValid } from "../../validation";
	import { registerPageComplete } from "../../tealium";
	import { acceptedFileUploadList, yesNoUnsureOptions } from "../../config";
	import Form from "../../components/Form.svelte";
	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
	import RadioGroup from "../../components/RadioGroup.svelte";
	import DatePicker from "../../components/DatePicker.svelte";
	import YesNoGroup from "../../components/YesNoGroup.svelte";
	import TextInput from "../../components/TextInput.svelte";
	import NumberInput from "../../components/NumberInput.svelte";
	import TextArea from "../../components/TextArea.svelte";
	import DropZone from "../../components/DropZone.svelte";
	import AutoCompleteSelector from "../../components/AutoCompleteSelector.svelte";
	import CheckboxButtonList from "../../components/CheckboxButtonList.svelte";
	import StoreList from "../../components/StoreList.svelte";
	import Select from "../../components/Select.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";
	import PageSection from "../../components/PageSection.svelte";
	import SaveAndClose from "../../components/SaveAndClose.svelte";
	import { onDestroy } from "svelte";

	const params = useParams();
	export let pageName = null;
	export let disabled = null;
	export let pageTitle = null;
	export let persistUrl = null;
	export let lastVisitedPage = null;
	export let businessId = null;
	let business = null;
	let validated = false,
		dateFinishValid = true,
		dateFinishError = false,
		employmentLocationsValid = true,
		employmentLocationsError = null;
	let hasFranchiseStores = false;

	let franchiseStores = ["Hungry Jack's", "KFC", "McDonald's", "On The Run", "Smokemart & Giftbox "];

	let selectedClaimDetails = null;
	let required = true,
		buttons = null;
	const storeLookupUrl = `/api/store-lookup?q=`;
	const fileUploaderId = "fileUploader";
	const fileUploadOptions = {
		url: "/api/file-upload?token=" + $model.registrationToken,
		acceptedFiles: acceptedFileUploadList,
		fileUploadToken: $model.registrationToken
	};

	const sundayPaidLeaveOptionList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, "10+"].map((val) => ({
		name: `${val}`,
		id: val
	}));

	let classificationOtherId;

	const initialise = () => {
		if ($params.slug) {
			business = $businesses.find((biz) => slugify(biz.businessName) === slugify($params.slug));
			// business = $model.selectedBusinesses.find((biz) => slugify(biz.businessName) === slugify($params.slug));
		} else {
			// business = $businesses.find((biz) => slugify(biz.businessName) === slugify($params.slug));
			business = $businesses.find((biz) => biz.businessId == businessId);
			console.log(business);
		}

		console.log(business, "business");

		if (business) {
			$model.currentBusiness = business;
			selectedClaimDetails = $model.claimDetails.find((cd) => cd.businessId === business.businessId);
			if (!selectedClaimDetails) {
				selectedClaimDetails = {
					businessId: business.businessId,
					dateStartWork: null,
					workingStill: "",
					dateFinishWork: null,
					typeOfEmployment: [],
					mainTypeOfEmployment: "",
					classification: [],
					mainClassificationId: "",
					classificationOther: null,
					hoursEachSunday: "",
					payslipsAvailable: "",
					overtimePaySundays: null,
					overTimePaySundaysFrequency: null,
					paidAnnualLeaveSundays: "",
					paidCarersLeaveSundays: "",
					paidPersonalLeaveSundays: "",
					outletType: 0,
					outletTypeId: null,
					howManySundays: 0,
					employmentLocations: [],
					businessRegistrationNumber: null,
					startedPriorToRelevantPeriod: null
				};
				$model.claimDetails.push(selectedClaimDetails);
			}

			if (
				business.businessPrefix &&
				$model.registrationNumber &&
				(!selectedClaimDetails.businessRegistrationNumber ||
					selectedClaimDetails.businessRegistrationNumber.startsWith("SAE-"))
			) {
				const regNumParts = $model.registrationNumber.split("-");
				if (regNumParts.length > 1) {
					selectedClaimDetails.businessRegistrationNumber = `${business.businessPrefix}-${regNumParts[1]}-${regNumParts[2]}`;
				}
			}

			classificationOtherId = $lookups[formatBusinessName(business.businessName)]?.filter(
				(l) => l.label === "Other"
			)[0]?.value;

			dateFinishValid =
				selectedClaimDetails.dateStartWork && selectedClaimDetails.dateFinishWork
					? unformatDate(selectedClaimDetails.dateFinishWork) >
						unformatDate(selectedClaimDetails.dateStartWork)
					: true;

			employmentLocationsValid = true;

			hasFranchiseStores = franchiseStores.includes(business.businessName);
			console.log(business.businessName, "HERE");
			console.log(hasFranchiseStores);
		}
	};

	onMount(() => {
		window.scrollTo({ top: 0, behavior: "smooth" });

		initialise();

		console.log("EmploymentDetails mounted");
	});

	onDestroy(() => {
		console.log("EmploymentDetails being destroyed");
	});

	$: initialise($params);

	$: {
		selectedClaimDetails.workingStill === "Yes" ? (selectedClaimDetails.dateFinishWork = null) : null;
		dateFinishValid =
			selectedClaimDetails.dateStartWork && selectedClaimDetails.dateFinishWork
				? unformatDate(selectedClaimDetails.dateFinishWork) > unformatDate(selectedClaimDetails.dateStartWork)
				: true;
	}

	const handleSubmit = async (e) => {
		buttons.blockNext();
		let errors = [...validateEmploymentLocations(), ...isValid(), ...validateDateFinish()];
		if (!errors.length) {
			let response = await model.saveModelAsync(persistUrl);
			if (!response.success) {
				console.log(response);
			} else {
				registerPageComplete(pageName, $model.contact.emailAddress, $model.contact.phoneNumber);
				buttons.next();
			}
		} else {
			errors[0].scrollIntoView({ behavior: "smooth" });
		}
		buttons.unblock();
	};

	const validateEmploymentLocations = () => {
		validated = true;
		employmentLocationsValid =
			selectedClaimDetails.employmentLocations && selectedClaimDetails.employmentLocations.length > 0;
		return !employmentLocationsValid ? [employmentLocationsError] : [];
	};

	const validateDateFinish = () => {
		validated = true;
		return !dateFinishValid ? [dateFinishError] : [];
	};

	$: {
		console.log(selectedClaimDetails);
	}

	const handleDateFinish = (e) => {
		dateFinishValid =
			selectedClaimDetails.dateStartWork && e.detail.date
				? e.detail.date > unformatDate(selectedClaimDetails.dateStartWork) &&
					e.detail.date > new Date(2019, 10, 1)
				: true;
	};

	const handleDateStart = (e) => {
		let threshold;
		switch (business.businessName) {
			case "McDonald's":
				threshold = new Date(2019, 10, 17);
				break;
			case "Hungry Jack's":
				threshold = new Date(2019, 11, 15);
				break;
			case "Big W":
			case "Woolworths Supermarkets":
				threshold = new Date(2019, 11, 4);
				break;
			case "Coles":
				threshold = new Date(2019, 11, 23);
				break;
			default:
				threshold = new Date(2019, 9, 31);
		}
		selectedClaimDetails.startedPriorToRelevantPeriod = e.detail.date < threshold;
	};

	let franchiseId = findLookupId($lookups.outletType, "Franchise Store");
	let bothId = findLookupId($lookups.outletType, "Both");

	// In your EmploymentDetails component
	let isMobile = false;

	const getEmploymentPeriodLabel = () => {
		if (!business) return "31 October 2019 and 31 December 2023";

		switch (business.businessName) {
			case "McDonald's":
				return "17 November 2019 and 31 December 2023";
			case "Big W":
			case "Woolworths Supermarkets":
				return "4 December 2019 and 31 December 2023";
			case "Hungry Jack's":
				return "15 December 2019 and 31 December 2023";
			case "Coles":
				return "23 December 2019 and 31 December 2023";
			default:
				return "31 October 2019 and 31 December 2023";
		}
	};

	onMount(() => {
		isMobile =
			window.matchMedia("(max-width: 768px)").matches ||
			/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
	});
</script>

{#key selectedClaimDetails.businessId}
	{#if selectedClaimDetails.businessId}
		<PageSection>
			<Form {disabled} id="form-claim-details" on:submit={handleSubmit}>
				<FormRow class="justify-content-center">
					<FormColumn>
						<h4 class="text-center">{@html projectSettings.classActionName} Shift Class Actions</h4>
						<h1 class="text-center">{business.businessName}</h1>
					</FormColumn>
				</FormRow>

				<div class:invalid={validated && !employmentLocationsValid}>
					<FormRow class="confirmation-box-shadow">
						<FormColumn>
							<label bind:this={employmentLocationsError}
								>Select the {business.businessName} outlets that you worked at between {getEmploymentPeriodLabel()}.<span
									class="isrequired">*</span
								></label>
							{#key business.businessId}
								<StoreList
									on:change={() => {
										if (validated) {
											employmentLocationsValid =
												selectedClaimDetails.employmentLocations?.length > 0;
										}
									}}
									readonly={disabled}
									businessId={selectedClaimDetails.businessId}
									bind:tags={selectedClaimDetails.employmentLocations} />
							{/key}
						</FormColumn>
					</FormRow>
					<div class:error-message={!employmentLocationsValid}>
						{#if validated && !employmentLocationsValid}
							Please select at least one outlet location.
						{/if}
					</div>
				</div>

				{#if hasFranchiseStores}
					<FormRow class="confirmation-box-shadow">
						<FormColumn>
							<RadioGroup
								{required}
								{disabled}
								name={`outletType${business.businessId}`}
								label="Did you work at a Corporate or Franchisee owned outlet?"
								optionList={$lookups.outletType}
								labelProperty="label"
								valueProperty="value"
								bind:value={selectedClaimDetails.outletTypeId} />
						</FormColumn>
					</FormRow>

					{#if selectedClaimDetails.outletTypeId == franchiseId || selectedClaimDetails.outletTypeId == bothId}
						<FormRow class="confirmation-box-shadow">
							<FormColumn>
								<label
									>If you worked at a Franchise store, please select or type the name/s of your employer/s (if known)</label>
								<div class="sublabel">
									Note: Your employer name should be listed on your payslips or payment summaries
									issued by your employer during the claim period
								</div>

								{#key business.businessId}
									<StoreList
										readonly={disabled}
										businessId={selectedClaimDetails.businessId}
										bind:tags={selectedClaimDetails.employerNames}
										businesses={false}
										business={business.businessName} />
								{/key}
							</FormColumn>
						</FormRow>
					{/if}
				{/if}

				<FormRow class="confirmation-box-shadow">
					<FormColumn>
						<DatePicker
							{required}
							{disabled}
							label={`Approximately when did you start working at ${business.businessName}?`}
							validator={true}
							start={new Date(1921, 10, 10)}
							end={new Date(2023, 11, 31)}
							placeholder="e.g. 01/05/2020"
							on:dateChange={handleDateStart}
							bind:formattedSelected={selectedClaimDetails.dateStartWork}
							openOnClass="calendar-icon" />
					</FormColumn>
				</FormRow>

				<FormRow class="confirmation-box-shadow">
					<FormColumn>
						<YesNoGroup
							{required}
							{disabled}
							name={`workingStill${business.businessId}`}
							label={`Are you still working at ${business.businessName}?`}
							bind:value={selectedClaimDetails.workingStill} />
					</FormColumn>
				</FormRow>

				{#if selectedClaimDetails.workingStill == "No"}
					<div class:invalid={validated && !dateFinishValid}>
						<FormRow class="confirmation-box-shadow">
							<FormColumn>
								<DatePicker
									{required}
									{disabled}
									label={`Approximately when did you finish working at ${business.businessName}?`}
									validator={true}
									start={isMobile ? new Date(2000, 10, 1) : new Date(2019, 10, 1)}
									end={new Date()}
									placeholder="e.g. 01/05/2020"
									bind:formattedSelected={selectedClaimDetails.dateFinishWork}
									on:dateChange={handleDateFinish}
									on:dateSelected={handleDateFinish}
									openOnClass="calendar-icon" />
							</FormColumn>
						</FormRow>
						<div bind:this={dateFinishError} class:error-message={!dateFinishValid}>
							{#if !dateFinishValid}
								Please select a valid date. Finish date cannot be earlier than start date and must be
								after 1 November 2019.
							{/if}
						</div>
					</div>
				{/if}

				<FormRow class="confirmation-box-shadow">
					<FormColumn>
						<CheckboxButtonList
							{disabled}
							name={`typeOfEmployment${business.businessId}`}
							label="Were you a casual, part-time or full-time employee while you worked at this outlet during this period? You may select more than one option if more than one option applies to you"
							optionList={$lookups.casualPartTimeFull}
							labelProperty="label"
							validator="checkboxRequired"
							valueProperty="value"
							bind:selected={selectedClaimDetails.typeOfEmployment} />
					</FormColumn>
				</FormRow>

				{#if selectedClaimDetails.typeOfEmployment.length > 1}
					<FormRow class="confirmation-box-shadow">
						<FormColumn>
							<RadioGroup
								{required}
								{disabled}
								name={`mainTypeOfEmployment${business.businessId}`}
								optionList={$lookups.casualPartTimeFull.filter((l) =>
									selectedClaimDetails.typeOfEmployment.includes(l.value)
								)}
								labelProperty="label"
								valueProperty="value"
								label={`Were you mainly ${$lookups.casualPartTimeFull
									.filter((l) => selectedClaimDetails.typeOfEmployment.includes(l.value))
									.map((l) => l.label.toLowerCase())
									.join(", ")
									.replace(/, ([^,]*)$/, " or $1")}?`}
								id="employmentTypeMain"
								bind:value={selectedClaimDetails.mainTypeOfEmployment} />
						</FormColumn>
					</FormRow>
				{/if}
				<FormRow class="confirmation-box-shadow">
					<FormColumn>
						<CheckboxButtonList
							{disabled}
							label="What classification/s most closely describe the role/s you performed? Please select all that apply."
							id="classification"
							bind:selected={selectedClaimDetails.classification}
							optionList={$lookups[formatBusinessName(business.businessName)]}
							labelProperty="label"
							validator="checkboxRequired"
							valueProperty="value" />
					</FormColumn>
				</FormRow>

				{#if selectedClaimDetails.classification.length > 1}
					<FormRow class="confirmation-box-shadow">
						<FormColumn>
							<RadioGroup
								{required}
								{disabled}
								name={`mainClassification${business.businessId}`}
								label="What was your main classification?"
								optionList={$lookups[formatBusinessName(business.businessName)].filter((l) =>
									selectedClaimDetails.classification.includes(l.value)
								)}
								cols={13}
								labelProperty="label"
								valueProperty="value"
								bind:value={selectedClaimDetails.mainClassificationId} />
						</FormColumn>
					</FormRow>
				{/if}

				{#if selectedClaimDetails.classification.includes(classificationOtherId)}
					<FormRow class="confirmation-box-shadow">
						<FormColumn>
							<TextInput
								{required}
								{disabled}
								label="Please specify other classification"
								bind:value={selectedClaimDetails.classificationOther}
								id="classificationOther" />
						</FormColumn>
					</FormRow>
				{/if}

				<FormRow class="confirmation-box-shadow">
					<FormColumn>
						<Select
							{required}
							{disabled}
							name="howManySundays"
							cols="12"
							label="How many Sundays did you work per month on average?"
							optionList={[
								{ label: 1, value: 1 },
								{ label: 2, value: 2 },
								{ label: 3, value: 3 },
								{ label: 4, value: 4 }
							]}
							textProperty="label"
							valueProperty="value"
							bind:value={selectedClaimDetails.howManySundays} />
					</FormColumn>
				</FormRow>

				<FormRow class="confirmation-box-shadow">
					<FormColumn>
						<NumberInput
							required
							{disabled}
							bind:value={selectedClaimDetails.hoursEachSunday}
							minvalue={1}
							maxvalue={12}
							errorMessage="Please enter a value between 1 and 12"
							label="How many hours was each Sunday shift on average?"
							id="hoursEachSunday" />
					</FormColumn>
				</FormRow>

				<FormRow class="confirmation-box-shadow">
					<FormColumn>
						<RadioGroup
							required
							{disabled}
							bind:value={selectedClaimDetails.overtimePaySundays}
							name={`overtimePaySundays${business.businessId}`}
							optionList={yesNoUnsureOptions}
							label="Did you ever perform overtime work on Sundays?"
							id="overtimePaySundays" />
					</FormColumn>
				</FormRow>

				{#if selectedClaimDetails.overtimePaySundays === "Yes"}
					<FormRow class="confirmation-box-shadow">
						<FormColumn>
							<RadioGroup
								{required}
								{disabled}
								label="How often did you perform overtime work on Sundays? (please select your best estimate)"
								bind:value={selectedClaimDetails.overTimePaySundaysFrequency}
								name={`overtimePaySundaysFrequency${business.businessId}`}
								optionList={[25, 50, 75, 100].map((val) => ({
									label: `${val}% of the time`,
									value: val
								}))}
								id="overtimePayDetails"
								rows="4" />
						</FormColumn>
					</FormRow>
				{/if}

				<FormRow class="confirmation-box-shadow">
					<FormColumn>
						<RadioGroup
							required
							{disabled}
							bind:value={selectedClaimDetails.paidAnnualLeaveSundays}
							name={`paidAnnualLeaveSundays${business.businessId}`}
							optionList={yesNoUnsureOptions}
							label="Did you take paid annual leave on a Sunday between November 2019 and 31 December 2023? "
							id="paidAnnualLeaveSundays" />
					</FormColumn>
				</FormRow>
				{#if selectedClaimDetails.paidAnnualLeaveSundays === "Yes"}
					<FormRow class="confirmation-box-shadow">
						<FormColumn>
							<Select
								required
								{disabled}
								bind:value={selectedClaimDetails.paidAnnualLeaveSundaysAmount}
								name={`paidAnnualLeaveSundays${business.businessId}`}
								optionList={sundayPaidLeaveOptionList}
								label="Select number of days paid annual leave was taken between November 2019 and 31 December 2023?"
								id="paidAnnualLeaveSundays" />
						</FormColumn>
					</FormRow>
				{/if}

				<FormRow class="confirmation-box-shadow">
					<FormColumn>
						<RadioGroup
							required
							{disabled}
							bind:value={selectedClaimDetails.paidCarersLeaveSundays}
							name={`paidCarersLeaveSundays${business.businessId}`}
							optionList={yesNoUnsureOptions}
							label="Did you take paid carer's leave on a Sunday between November 2019 and 31 December 2023? "
							id="paidCarersLeaveSundays" />
					</FormColumn>
				</FormRow>
				{#if selectedClaimDetails.paidCarersLeaveSundays === "Yes"}
					<FormRow class="confirmation-box-shadow">
						<FormColumn>
							<Select
								required
								{disabled}
								bind:value={selectedClaimDetails.paidCarersLeaveSundaysAmount}
								name={`paidCarersLeaveSundays${business.businessId}`}
								optionList={sundayPaidLeaveOptionList}
								label="Select number of days paid carer's leave was taken between November 2019 and 31 December 2023?"
								id="paidCarersLeaveSundays" />
						</FormColumn>
					</FormRow>
				{/if}

				<FormRow class="confirmation-box-shadow">
					<FormColumn>
						<RadioGroup
							required
							{disabled}
							bind:value={selectedClaimDetails.paidPersonalLeaveSundays}
							name={`paidPersonalLeaveSundays${business.businessId}`}
							optionList={yesNoUnsureOptions}
							label="Did you take paid personal leave on a Sunday between November 2019 and 31 December 2023? "
							id="paidPersonalLeaveSundays" />
					</FormColumn>
				</FormRow>
				{#if selectedClaimDetails.paidPersonalLeaveSundays === "Yes"}
					<FormRow class="confirmation-box-shadow">
						<FormColumn>
							<Select
								required
								{disabled}
								bind:value={selectedClaimDetails.paidPersonalLeaveSundaysAmount}
								name={`paidPersonalLeaveSundays${business.businessId}`}
								optionList={sundayPaidLeaveOptionList}
								label="Select number of days paid personal leave was taken between November 2019 and 31 December 2023?"
								id="paidPersonalLeaveSundays" />
						</FormColumn>
					</FormRow>
				{/if}

				<FormRow class="confirmation-box-shadow">
					<FormColumn>
						<YesNoGroup
							{required}
							{disabled}
							name={`payslip${business.businessId}`}
							label={`Do you have a payslips available?`}
							bind:value={selectedClaimDetails.payslipsAvailable} />
					</FormColumn>
				</FormRow>

				{#if selectedClaimDetails.payslipsAvailable === "Yes"}
					<FormRow class="confirmation-hide">
						<FormColumn>
							<label>Please upload any payslips available that show you worked a Sunday shift</label>
							<p class="subHeading">Please note: All payslips uploaded will appear here.</p>
							<DropZone
								options={fileUploadOptions}
								id={fileUploaderId}
								{disabled}
								message="<strong>Upload files for your registration</strong><br />Drag files here or click to upload"
								bind:documentList={$model.documentList}
								filenamePrefix={slugify(business.businessName)}></DropZone>
						</FormColumn>
					</FormRow>
				{/if}

				<FormRow class="confirmation-hide">
					<FormColumn>
						<NavigationButtons bind:buttons nextPageLabel={$model.confirmationPage ? "Next" : "Next"} />
					</FormColumn>
				</FormRow>

				<!--We might need to put save and close back in at some point so leaving this here-->
				<!-- <FormRow class="confirmation-hide">
					<FormColumn class="last">
						<SaveAndClose>Save and Close</SaveAndClose>
					</FormColumn>
				</FormRow> -->
			</Form>
		</PageSection>
	{/if}
{/key}

<style>
	label span.isrequired {
		color: var(--color-error);
		left: 4px;
		position: relative;
		font-size: 1.2em;
	}

	.subHeading {
		font-size: 0.8em;
		margin: 0;
		font-style: italic;
	}
</style>
